import { FiImage, FiPackage } from 'react-icons/fi';

const PlaceholderImage = ({ type = 'product', className = '', size = 'default' }) => {
  const sizeClasses = {
    small: 'w-12 h-12',
    default: 'w-full h-full',
    large: 'w-64 h-64'
  };

  const icons = {
    product: FiPackage,
    image: FiImage,
    user: FiImage
  };

  const Icon = icons[type] || FiImage;

  return (
    <div className={`bg-gray-100 flex items-center justify-center ${sizeClasses[size] || sizeClasses.default} ${className}`}>
      <svg
        className="w-1/2 h-1/2 text-gray-300"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        {type === 'product' ? (
          <>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
          </>
        ) : (
          <>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </>
        )}
      </svg>
    </div>
  );
};

export default PlaceholderImage;

